import React, {useState} from "react";
import styled from "styled-components";

const PLACEHOLDER_IMAGE = "https://via.placeholder.com/150";

const ProductItem = ({
  product,
  selectedQuantity,
  availableQuantity,
  onQuantityChange,
  onAddToCart,
  onInfoClick,
}) => {
    const [isAnimating, setIsAnimating] = useState(false);

    const handleAddToCartClick = () => {
        if (selectedQuantity === 0) return;

        setIsAnimating(true);

        const productCard = document.querySelector(`[data-product-id="${product.id}"]`);
        const productImage = productCard?.querySelector('img');

        if (productImage) {
             const imageRect = productImage.getBoundingClientRect();
            const cartIcon = document.querySelector('[alt="Cart"]');
            let cartX = window.innerWidth / 2 - 15; // Default fallback
            let cartY = window.innerHeight - 120;

            if (cartIcon) {
                const cartRect = cartIcon.getBoundingClientRect();
                cartX = cartRect.left + cartRect.width / 2 - 15; // Centrera på ikonen
                cartY = cartRect.top + cartRect.height / 2 - 15;
            }

            const flyingImage = productImage.cloneNode(true);
            flyingImage.style.position = 'fixed';
            flyingImage.style.left = `${imageRect.left}px`;
            flyingImage.style.top = `${imageRect.top}px`;
            flyingImage.style.width = `${imageRect.width}px`;
            flyingImage.style.height = `${imageRect.height}px`;
            flyingImage.style.zIndex = '9999';
            flyingImage.style.pointerEvents = 'none';
            flyingImage.style.borderRadius = '8px';
            flyingImage.style.transition = 'all 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
            flyingImage.style.boxShadow = '0 4px 20px rgba(0,0,0,0.3)';

            document.body.appendChild(flyingImage);

            setTimeout(() => {
                flyingImage.style.left = `${cartX}px`;
                flyingImage.style.top = `${cartY}px`;
                flyingImage.style.width = '30px';
                flyingImage.style.height = '30px';
                flyingImage.style.opacity = '0.8';
            }, 50);

            setTimeout(() => {
                document.body.removeChild(flyingImage);
                setIsAnimating(false);

                const event = new CustomEvent('productAddedToCart', {
                    detail: { productId: product.id, quantity: selectedQuantity }
                });
                window.dispatchEvent(event);

                onAddToCart(product, selectedQuantity);
            }, 650);
        } else {
            setTimeout(() => {
                setIsAnimating(false);
                onAddToCart(product, selectedQuantity);
            }, 100);
        }
    };

    return (
        <Container data-product-id={product.id}>
            <ImageContainer>
                <ProductImage
                    src={product.imageURL}
                    onError={(e) => {
                        console.warn("Image loading error:", e);
                        e.target.src = PLACEHOLDER_IMAGE;
                    }}
                    alt={product.title}
                />
                <InfoIcon onClick={onInfoClick}>i</InfoIcon>
            </ImageContainer>
            <ProductDetails>
                <ProductTitle>{product.title || "No title"}</ProductTitle>
                <ProductPrice>{product.price || 0} kr</ProductPrice>
            </ProductDetails>
            <ShopButtonContainer>
                <ShopButton
                    onClick={handleAddToCartClick}
                    disabled={availableQuantity <= 0}
                >
                    {availableQuantity > 0 ? "Köp" : "Slut"}
                </ShopButton>
            </ShopButtonContainer>
        </Container>
    );
};

export default ProductItem;

const Container = styled.div`
    width: 100%; 
    padding: 10px 10px 15px 10px;
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(12px);
    border: 1px solid rgba(255, 255, 255, 0.9);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    transition: all 0.3s ease;
    overflow: hidden;
    text-align: center;
    height: 200px;
    margin: 0; 

    &:hover {
        background: rgba(255, 255, 255, 0.9);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
        transform: translateY(-3px);
    }
`;

const ImageContainer = styled.div`
    width: 52%;         
    height: 0;
    padding-bottom: 52%;  
    margin-bottom: 6px;   
    border-radius: 12px;
    overflow: hidden;
    position: relative;
`;

const ProductImage = styled.img`
    position: absolute;
    top: 2px;   
    left: 2px;
    right: 2px;
    bottom: 2px;
    object-fit: contain;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    border-radius: 8px;
    background-color: transparent;
`;


const InfoIcon = styled.div`
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 16px;
    height: 16px;
    background: rgba(37, 37, 37, 0.85);
    backdrop-filter: blur(5px);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 10px;
    font-weight: bold;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(37, 37, 37, 0.95);
        transform: scale(1.15);
    }
`;

const ProductDetails = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 6px;
    min-height: 30px;
`;

const ProductTitle = styled.h3`
    font-size: 12px;
    font-weight: 400;
    color: #252525;
    text-align: center;
    margin: 0 0 4px 0;


    line-height: 1.25;     
    height: 2.5em;        
    //overflow: hidden;

    display: -webkit-box;
    -webkit-line-clamp: 2; 
    -webkit-box-orient: vertical;

    white-space: normal;
    word-break: break-word;
    hyphens: auto;
    
    margin-top: 7px;
`;


const ProductPrice = styled.p`
    font-size: 14px;
    font-weight: 600;
    color: #252525;
    margin: 0;
`;

const ShopButtonContainer = styled.div`
  width: 100%;
  margin-top: auto;
`;

const ShopButton = styled.button`
  background: ${props => props.disabled
    ? 'rgba(156, 163, 175, 0.5)'
    : 'rgba(37, 37, 37, 0.9)'};
  backdrop-filter: blur(10px);
  padding: 8px 12px;
  border-radius: 12px;
  color: #ffffff;
  font-size: 11px;
  font-weight: 600;
  width: 100%;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  border: none;
  transition: all 0.3s ease;
  box-shadow: ${props => props.disabled
    ? 'none'
    : '0 2px 6px rgba(37, 37, 37, 0.3)'};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;
  min-height: 28px;
  opacity: ${props => props.disabled ? 0.6 : 1};

  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
    transition: left 0.5s ease;
  }

  &:hover:not(:disabled) {
    background: rgba(37, 37, 37, 1);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(37, 37, 37, 0.4);

    &:before {
      left: 100%;
    }
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }
`;